import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild, ElementRef, ChangeDetectorRef, HostListener } from '@angular/core';
declare const jQuery: any;

@Component({
  selector: 'app-body',
  templateUrl: './body.component.html',
  styleUrls: ['./body.component.scss']
})
export class BodyComponent implements AfterViewInit, OnInit {

  @ViewChild('canvas') public canvas: ElementRef;
  private cx: CanvasRenderingContext2D;

  public ngAfterViewInit() {
    const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
    this.cx = canvasEl.getContext('2d');
    let image = new Image();
    if (this.valueBody == "") {
      image.src = "../../../../assets/images/pediatric-boy-image.png";
    } else {
      image.src = this.valueBody;
    }
    image.onload = () => {
      if (window.innerWidth > 760) {
        this.cx.drawImage(image, 0, 0, 654, 500, 0, 0, 654, 500);
      }
      else if (window.innerWidth > 550) {
        this.cx.drawImage(image, 0, 0, 654, 500, 0, 0, 523, 400);
      }
        else {
          this.cx.drawImage(image, 0, 0, 654, 500, 0, 0, 392, 300);
        }
      let dataURL = this.canvas.nativeElement.toDataURL();
      this.arrayPoints = [];
      this.arrayPoints.push(dataURL);
    }
  }

  @Input() formItem: any;
  @Input() invalidForm: any;
  @Input() formId: any;

  @Output() callUpdate = new EventEmitter();
  @Output() invalidFormChange = new EventEmitter<boolean>();

  isRequired: string;
  formTitle: string;
  offset: any;

  arrayPoints: Array<any> = [];

  constructor(private ref:ChangeDetectorRef) { }

  get valueBody() {
    return this.formItem.value;
  }


  set valueBody(value: any) {
    this.formItem.value = value;
  }

  ngOnInit() {
    this.ref.detectChanges();
    this.isRequired = this.formItem.item.isRequired;
    delete this.formItem.boolValue;
    this.formTitle = this.formItem.item.labelField;
  }

  @HostListener('window:resize')
  onWindowResize() {
    let canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
    this.cx = canvasEl.getContext('2d');
    this.cx.clearRect(0, 0, 654, 500);
    this.clearImage();
  }

  drawCircle(e) {
    let screenWidth=window.innerWidth;
    this.offset = this.canvas.nativeElement.getBoundingClientRect();
    let relativeX = (e.clientX - this.offset.left);
    let relativeY = (e.clientY - this.offset.top);


    if(screenWidth>=1250){
      relativeX = (e.clientX - this.offset.left)*0.97;
      relativeY = (e.clientY - this.offset.top);
    }

    else if(screenWidth>=450 && screenWidth<500){
      relativeX = (e.clientX - this.offset.left)*(1.1);
      relativeY = (e.clientY - this.offset.top)*(1.13);
    }
     else if(screenWidth>=500 && screenWidth<550){
       relativeX = (e.clientX - this.offset.left)*(1.1);
       relativeY = (e.clientY - this.offset.top)*(1.13);
     }
    else if(screenWidth>=550 && screenWidth<600){
      relativeX = (e.clientX - this.offset.left)*(1.1);
      relativeY = (e.clientY - this.offset.top)*(1.13);
    }


    this.cx = this.canvas.nativeElement.getContext('2d');
    this.cx.fillStyle = "#2C3790";
    this.cx.beginPath();
    this.cx.arc(relativeX, relativeY, 8, 0, Math.PI * 2, true);
    this.cx.fill();
    this.cx.closePath();
    let dataURL = this.canvas.nativeElement.toDataURL();
    this.valueBody = dataURL;
    this.arrayPoints.push(dataURL);
  }

  undoLast() {
    if (this.arrayPoints.length > 1) {
      const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
      this.cx = canvasEl.getContext('2d');
      let image = new Image();
      image.src = this.arrayPoints[this.arrayPoints.length - 2];
      this.arrayPoints.pop();
      image.onload = () => {
        this.cx.drawImage(image, 0, 0);
        this.cx = this.canvas.nativeElement.getContext('2d');
        let dataURL = this.canvas.nativeElement.toDataURL();
        this.valueBody = dataURL;
      }
    }
  }

 updateConditional() {
    this.offset = this.canvas.nativeElement.getBoundingClientRect();
    if (this.formItem.item.isConditional) {
      this.callUpdate.emit();
    }
  }

  clearImage() {
    const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
    this.cx = canvasEl.getContext('2d');
    let image = new Image();
    image.src = "../../../../assets/images/pediatric-boy-image.png";
    image.onload = () => {
      if (window.innerWidth > 700) {
              this.cx.drawImage(image, 0, 0, 654, 500, 0, 0, 654, 500);
            }
            else if (window.innerWidth > 550)
              this.cx.drawImage(image, 0, 0, 654, 500, 0, 0, 523, 400);
              else {
                this.cx.drawImage(image, 0, 0, 654, 500, 0, 0, 392, 300);
              }
      this.cx = this.canvas.nativeElement.getContext('2d');
      let dataURL = this.canvas.nativeElement.toDataURL();
      this.valueBody = dataURL;
      this.arrayPoints = [];
      this.arrayPoints.push(dataURL);
    }
  }
}
